import TechnologyDetailPage from "@/pages/technologies/components/TechnologyDetailPage";

export default function FlutterTechPage() {
  return <TechnologyDetailPage slug="flutter" />;
}